/* TDT · Cinta de texto — bucle infinito */
if (!customElements.get('tdt-text-marquee')) {
  class TdtTextMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.tdt-ct__track');
      this.original = this.querySelector('.tdt-ct__group');
      if (!this.track || !this.original) return;

      this.speed = parseFloat(this.dataset.speed) || 60;
      let t;
      this.onResize = () => {
        clearTimeout(t);
        t = setTimeout(() => this.build(), 200);
      };

      // Esperar a las fuentes para medir bien el ancho del texto
      (document.fonts?.ready || Promise.resolve()).then(() => this.build());
      window.addEventListener('resize', this.onResize);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-running', entry.isIntersecting);
        });
        this.observer.observe(this);
      } else {
        this.classList.add('is-running');
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      this.observer?.disconnect();
    }

    build() {
      this.track.querySelectorAll('.tdt-ct__group[aria-hidden]').forEach((g) => g.remove());

      const groupWidth = this.original.getBoundingClientRect().width;
      if (!groupWidth) return;

      const copies = Math.max(1, Math.ceil(this.offsetWidth / groupWidth)) + 1;
      for (let i = 1; i < copies; i++) {
        const clone = this.original.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        this.track.appendChild(clone);
      }

      this.style.setProperty('--tdt-ct-shift', groupWidth + 'px');
      this.style.setProperty('--tdt-ct-duration', (groupWidth / this.speed).toFixed(2) + 's');

      this.track.style.animation = 'none';
      void this.track.offsetWidth;
      this.track.style.animation = '';
    }
  }

  customElements.define('tdt-text-marquee', TdtTextMarquee);
}
